import createLucideIcon from '../createLucideIcon';

const Slash = createLucideIcon('SlashIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '4.93', y1: '4.93', x2: '19.07', y2: '19.07', key: 'bqqkff' }],
]);

export default Slash;
